import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormatOptions } from 'luxon';
import { TimezoneTagToNameMap } from '@sondermind/features/public-facing/provider-calendar';

@Pipe({
  name: 'formatRequestedTimeSlot',
  standalone: true,
})
export class RequestedTimeSlotPipe implements PipeTransform {
  transform(date: Date, timeZone: string, longMonth: boolean = false): string {
    if (timeZone && TimezoneTagToNameMap[timeZone]) {
      const options = {
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        month: longMonth ? 'long' : 'short',
        day: 'numeric',
        timeZoneName: 'short',
        timeZone,
      } as DateTimeFormatOptions;
      const formatter = new Intl.DateTimeFormat('en-US', options);

      // Apparently the long form of the month adds in the 'at' itself, but we want
      // the at separator in all use cases
      if (!longMonth) {
        const dateStrArray = formatter.format(date).split(' ');

        dateStrArray.splice(3, 0, 'at');

        return dateStrArray.join(' ');
      }

      return formatter.format(date);
    }

    return 'Invalid date';
  }
}
